import { Component, Inject, Input, OnChanges, SimpleChanges } from "@angular/core";
import { Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { AppComponent } from "../app/app.component";

@Component({
    selector: "prequalificationdrver",
    template: require('./prequalificationdriver.component.html'),
    styles: [require('./prequalificationdriver.component.css')]
})
export class PrequalificationDriverComponent implements OnChanges {

    report: CollisionReport;
    constructor(private appcomponent: AppComponent, private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string,
        private router: Router) {
        this.report = appcomponent.getReport();
        if (this.report.CollisionReportUniqueId == null) {
            this.reportGetSync();
            this.router.navigate([this.router.url])
        }

        if (this.report.IsNew) {
            this.router.navigate(["home"]);
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        if (typeof changes['report'] !== "undefined") {
            // retrieve the report variable change info
            var change = changes['report'];
            // only perform the task if the value has been changed
            if (!change.isFirstChange()) {
                // execute the Http request and retrieve the result
                //DO SOmething
            }
        }
        else
            console.log("Undefined");
    }
    onBack(): void {
        this.BackAndPost("yourinfo");
    }
    private BackAndPost(page: string): void {

        this.report.CurrentPage = page;
     //   this.appcomponent.setReport(this.report);
        this.router.navigate([page]);
    }
    onSubmit(): void {
        //   alert('SUCCESS!! :-)\n\n' + JSON.stringify(this.report));
        this.ValidateAndPost("statement");

    }

    onDidReportDirectlyChange(value: boolean): void {
        this.report.DidYouReportDirectly = value;
    }
    onWereYouInjuredChange(value: boolean): void {
        this.report.WereYouInjured = value;
    }
    onFailToRemainChange(value: boolean): void {
        this.report.FailToRemain = value;
    }
    onPoliceAttendedChange(value: boolean): void {
        this.report.PoliceAttended = value;
    }
    onApproachedChange(value: boolean): void {
        this.report.Approached = value;
    }

    onRideShareChange(value: boolean): void {
        this.report.RideShare = value;
    }
    onRentalChange(value: boolean): void {
        this.report.WasVehicleRental = value;
    }
    onSeatbeltChange(value: boolean): void {
        this.report.WasSeatbeltUsed = value;
    }
    onTowingChange(value: boolean): void {
        this.report.Towing = value;
    }
    onAirbagDeployedChange(value: boolean): void {
        this.report.AirbagDeployed = value;
    }
    onTowedChange(value: boolean): void {
        this.report.Towed = value;
    }
    onHaveContactedInsuranceChange(value: boolean): void {
        this.report.HaveContactedInsurance = value;
    }
    onWillYouBeLeavingVehicleChange(value: boolean): void {
        this.report.WillYouBeLeavingVehicle = value;
    }
    


    private ValidateAndPost(page: string) {
        if (this.IsValid()) {
            this.report.IsPrequalificationPageValid = true;
            this.report.CurrentPage = page;
            this.appcomponent.setReport(this.report);
            this.router.navigate([page]);
        }
        else {
            alert("Please select all mandatory questions.");
        }
    }

    private IsValid(): boolean {
        if (this.report.DidYouReportDirectly == null ||
            this.report.WereYouInjured == null ||
            this.report.FailToRemain == null ||
            this.report.PoliceAttended == null ||
            this.report.Approached == null ||
            this.report.RideShare == null ||
            this.report.Towing == null ||
            this.report.AirbagDeployed == null ||
            this.report.Towed == null ||
            this.report.HaveContactedInsurance == null ||
            this.report.WillYouBeLeavingVehicle == null) {

            return false;
        }

        return true;
    }

    reportGetSync(): void {
        var url = this.baseUrl + "api/report";
        this.http
            .get(url)
            .toPromise().then(result => {
                var v = result as CollisionReport;
                this.report = v;
            });
    }
}